import { Modal } from '@mantine/core';
import { useMounted } from '@mantine/hooks';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'shared/lib';
import { myBetsModalModel } from '../../model';
import { MyBetsModalPagination } from '../my-bets-modal-pagination';
import { MyBetsModalTable } from '../my-bets-modal-table';
import cls from './my-bets-modal.module.scss';

export type MyBetsModalProps = {
	targetId: string;
};

export const MyBetsModal = ({ targetId }: MyBetsModalProps) => {
	const { t } = useTranslation();
	const mounted = useMounted();
	const sm = useBreakpoint('sm', false);

	const [opened, close] = useUnit([
		myBetsModalModel.myBetsSwitcher.$active,
		myBetsModalModel.myBetsSwitcher.disable,
	]);

	return (
		mounted && (
			<Modal
				opened={opened}
				classNames={{
					overlay: cls.myBetsModalOverlay,
					inner: cls.myBetsModalInner,
					content: cls.myBetsModalContent,
					body: cls.myBetsModalBody,
				}}
				title={t('my-bets-modal.title')}
				portalProps={{
					target: document.getElementById(targetId)!,
				}}
				size={sm ? 'md' : 'sm'}
				onClose={close}
			>
				<MyBetsModalTable />
				<MyBetsModalPagination />
			</Modal>
		)
	);
};
